import { useHistory } from "react-router-dom"
import { buildRoute, eRoutes, IERoute } from "../routes"

export function useRedirectRoute() {
  const history = useHistory()

  function redirect(
    route: IERoute,
    params: Record<string, any> = {},
    opts: { qs?: Record<string, string> } = {},
    state?: typeof history.location.state,
  ) {
    return history.push(buildRoute(eRoutes[route], params, opts), state)
  }

  return redirect
}
